import { Analytics } from "@vercel/analytics/react";
import { useEffect, useState } from "react";
import { CookiesProvider } from "react-cookie";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DVMatchCoding from "./components/matches/DVMatchCoding";
import HittingChartReport from "./components/matches/HittingChartReport";
import VideoAnalysis from "./components/matches/VideoAnalysis";
import Playlist from "./components/playlist/Playlist";
import { AlertProvider } from "./context/Alert/AlertContext";
import { LanguageProvider } from "./context/Language/LanguageContext";
import { VBLiveAPIProvider } from "./context/VBLiveAPI/VBLiveAPIContext";
import About from "./pages/About";
import Admin from "./pages/Admin";
import AIReports from "./pages/AIReports";
import CodingPage from "./pages/CodingPage";
import ForgotPassword from "./pages/ForgotPassword";
import Home from "./pages/Home";
import Information from "./pages/Information";
import Input from "./pages/Input";
import Live from "./pages/Live";
import MainPage from "./pages/MainPage";
import MatchesList from "./pages/MatchesList";
import MomentumChartPage from "./pages/MomentumChartPage";
import MultiSessions from "./pages/MultiSessions";
import NewMatch from "./pages/NewMatch";
import NotFound from "./pages/NotFound";
import PlayersPage from "./pages/PlayersPage";
import PlaylistsList from "./pages/PlaylistsList";
import ServeReceiveReportPage from "./pages/ServeReceiveReportPage";
import Session from "./pages/Session";
import SettingsPage from "./pages/SettingsPage";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import TeamsPage from "./pages/TeamsPage";
import Translation from "./pages/Translation";
import VideoAnalysisFiltersPage from "./pages/VideoAnalysisFiltersPage";

function App() {
  const [currentTheme, setCurrentTheme] = useState(
    localStorage.getItem("theme") ? localStorage.getItem("theme") : "garden"
  );

  // The theme is applied to the root <html> element so it themes the entire
  // document — including the html/body margins and any overscroll area — rather
  // than only a wrapper <div>. This is the single source of truth; other pages
  // (e.g. the theme picker in MainPage) update the same attribute and persist
  // the choice to localStorage, so a refresh keeps the selected theme.
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", currentTheme);
  }, [currentTheme]);

  return (
    <div className="min-h-screen bg-base-100">
      <CookiesProvider>
        <VBLiveAPIProvider>
          <AlertProvider>
            <LanguageProvider>
              <Router>
                <div
                  className="flex flex-col h-screen"
                  style={{ paddingBottom: "0px" }}
                >
                  {/* <Navbar /> */}
                  <main className="mx-2 px-2 pb-2">
                    <Analytics />
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/signin" element={<SignIn />} />
                      <Route path="/signup" element={<SignUp />} />
                      <Route path="/live" element={<Live />} />
                      <Route path="/mainpage" element={<MainPage />} />
                      <Route path="/matcheslist" element={<MatchesList />} />
                      <Route path="/codingpage" element={<CodingPage />} />
                      <Route
                        path="/dvmatchcoding"
                        element={<DVMatchCoding />}
                      />
                      <Route path="/playlistslist" element={<PlaylistsList />} />
                      <Route
                        path="/forgotpassword"
                        element={<ForgotPassword />}
                      />
                      <Route path="/about" element={<About />} />
                      <Route path="/information" element={<Information />} />
                      <Route path="/settings" element={<SettingsPage />} />
                      <Route path="/session" element={<Session />} />
                      <Route path="/multisessions" element={<MultiSessions />} />
                      <Route path="/aireports" element={<AIReports />} />
                      <Route path="/playlist" element={<Playlist />} />
                      <Route path="/videoanalysis" element={<VideoAnalysis />} />
                      <Route path="/videoanalysisfilters" element={<VideoAnalysisFiltersPage />} />
                      <Route path="/momentumchart" element={<MomentumChartPage />} />
                      <Route path="/servereceivereport" element={<ServeReceiveReportPage />} />
                      <Route
                        path="/hittingchartreport"
                        element={<HittingChartReport />}
                      />
                      <Route path="/newmatch" element={<NewMatch />} />
                      <Route path="/input" element={<Input />} />
                      <Route path="/teams" element={<TeamsPage />} />
                      <Route path="/players" element={<PlayersPage />} />
                      <Route path="/translation" element={<Translation />} />
                      <Route path="/admin" element={<Admin />} />
                      <Route path="/*" element={<NotFound />} />
                    </Routes>
                  </main>
                  {/* <Footer /> */}
                </div>
              </Router>
            </LanguageProvider>
          </AlertProvider>
          <ToastContainer />
        </VBLiveAPIProvider>
      </CookiesProvider>
    </div>
  );
}

export default App;
